import { BlogPageHero } from '../../../components/Blog/BlogPageHero';
import { BlogPostList } from '../../../components/Blog/BlogPostList';
import BasicPage from '../../../components/Layouts/BasicPage';
import { getAllWhitelabeledBlogPosts } from '../../../lib/contentful';
import { Companies } from '../../../util/CompanyList';
import { Routes } from '../../../util/routes';
import { withOnboardingRequired } from '../../../util/withOnboardingRequired';

export const BlogPage = ({ posts }) => {
  return (
    <BasicPage className="blog-page">
      <BlogPageHero />
      <div className="container">
        <div className=" py-6 px-7">
          <BlogPostList posts={posts} />
        </div>
        <div className="right-col py-6 px-7"></div>
      </div>
    </BasicPage>
  );
};

export async function getStaticPaths() {
  return {
    paths: Companies.map(({ slug }) => Routes.blog(slug)),
    fallback: 'blocking',
  };
}

export async function getStaticProps() {
  const blogPosts = await getAllWhitelabeledBlogPosts();

  return {
    props: {
      posts: blogPosts ?? [],
    },
    revalidate: 1,
  };
}

export default withOnboardingRequired(BlogPage);
